import { API_BASE_URL } from "../urls.api";

export const GET_AVAILABLE_DEVICE_VERSION = `${API_BASE_URL}/device-version/available`;

export const REQUEST_OTA_UPDATE_DEVICE_FIRMWARE = `${API_BASE_URL}/request-ota-update`;
